module.exports = __webpack_public_path__ + "static/media/popcorn-magic.b65821a7.png";